import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

const useUpdateDeclaracionTrabajadorCuentaPropiaByID = () => {
  const [loadingUpdateDeclaracionTrabajadorCuentaPropiaById, setLoadingCreateDeclaracionTrabajadorCuentaPropia] = useState(false);
  const [successUpdateDeclaracionTrabajadorCuentaPropiaById, setSuccessCreateDeclaracionTrabajadorCuentaPropia] = useState(false);
  const [errorUpdateDeclaracionTrabajadorCuentaPropiaById, setErrorCreateDeclaracionTrabajadorCuentaPropia] = useState(null);
  const [dataUpdateDeclaracionTrabajadorCuentaPropiaById, setDataDeclaracionTrabajadorCuentaPropia] = useState(null);

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";

  const apiRecord = new record.RecordService(
    BASE_URL,
    FUNCTIONS_KEY
  );

  // UPDATE
  const updateDeclaracionTrabajadorCuentaPropiaById = async (
    userId: string,
    formId: string,
    data: any,
    _cb?: (data: any) => void
  ) => {
    setLoadingCreateDeclaracionTrabajadorCuentaPropia(true);
    setSuccessCreateDeclaracionTrabajadorCuentaPropia(false);
    setErrorCreateDeclaracionTrabajadorCuentaPropia(null);


    apiRecord.updateDeclaracionTrabajadorCuentaPropiaByID(userId, formId, data)
      .then((res: any) => {
        setLoadingCreateDeclaracionTrabajadorCuentaPropia(false);
        setSuccessCreateDeclaracionTrabajadorCuentaPropia(true);
        setDataDeclaracionTrabajadorCuentaPropia(res.data);

        if (typeof _cb === "function") {
          _cb(res.data);
        }
      })
      .catch((err: any) => {
        console.log(err);
        setLoadingCreateDeclaracionTrabajadorCuentaPropia(false);
        setErrorCreateDeclaracionTrabajadorCuentaPropia(err.response?.data);
      });
  };

  return {
    updateDeclaracionTrabajadorCuentaPropiaById,
    loadingUpdateDeclaracionTrabajadorCuentaPropiaById,
    successUpdateDeclaracionTrabajadorCuentaPropiaById,
    errorUpdateDeclaracionTrabajadorCuentaPropiaById,
    dataUpdateDeclaracionTrabajadorCuentaPropiaById
  };
};

export default useUpdateDeclaracionTrabajadorCuentaPropiaByID;
